import { sanitizeFormValues } from "./sanitize";

export function validatePatientForm(form) {
  const safe = sanitizeFormValues(form);
  const errors = {};
  if (!safe.first_name) errors.first_name = "First name is required.";
  if (!safe.last_name) errors.last_name = "Last name is required.";
  if (!safe.email) {
    errors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(safe.email)) {
    errors.email = "Enter a valid email address.";
  }
  return errors;
}
export const validateEmailForm = (form) => {
  const safe = sanitizeFormValues(form);
  const errors = {};
  if (!safe.date?.trim()) errors.date = "Date is required.";
  if (!safe.time?.trim()) errors.time = "Time is required.";
  return errors;
};
